export default {
  name: 'CollUtil',
  /**
   * 排序
   */
  sort(objList, propFun, desc = false) {
    return objList.sort((a, b) => desc ? (propFun(b) - propFun(a)) : (propFun(a) - propFun(b)))
  },
  sortFirst(objList, propFun, desc = false, defVal) {
    if (objList && objList.length) {
      return this.sort(objList, propFun, desc)[0]
    }
    return defVal
  },
  listToMap: function (list, keyPropName) {
    const map = {}
    if (list) {
      for (const obj of list) {
        map[obj[keyPropName]] = obj
      }
    }
    return map
  },
  listToMapFun: function (list, keyPropFun) {
    const map = {}
    if (list) {
      for (const obj of list) {
        map[keyPropFun(obj)] = obj
      }
    }
    return map
  },
  listToListMap: function (list, propName, valFun) {
    const map = {}
    valFun = valFun || function (o) {
      return o
    }
    if (list) {
      for (const obj of list) {
        const prop = obj[propName] || ''
        let list = map[prop]
        if (!list) {
          list = []
          map[prop] = list
        }
        list.push(valFun(obj))
      }
    }
    return map
  },
  contains: function (list, o) {
    return list.indexOf(o) > -1
  },
  // // 多维数组排列组合
  // doExchange(arr) {
  //   const len = arr.length
  //   // 当数组大于等于2个的时候
  //   if (len >= 2) {
  //     // 第一个数组的长度
  //     const len1 = arr[0].length
  //     // 第二个数组的长度
  //     const len2 = arr[1].length
  //     // 2个数组产生的组合数
  //     const lenBoth = len1 * len2
  //     //  申明一个新数组
  //     const items = new Array(lenBoth)
  //     // 申明新数组的索引
  //     let index = 0
  //     for (let i = 0; i < len1; i++) {
  //       for (let j = 0; j < len2; j++) {
  //         if (arr[0][i] instanceof Array) {
  //           items[index] = arr[0][i].concat(arr[1][j])
  //         } else {
  //           items[index] = [arr[0][i]].concat(arr[1][j])
  //         }
  //         index++
  //       }
  //     }
  //     const newArr = new Array(len - 1)
  //     for (let i = 2; i < arr.length; i++) {
  //       newArr[i - 1] = arr[i]
  //     }
  //     newArr[0] = items
  //     return doExchange(newArr)
  //   } else {
  //     return arr[0]
  //   }
  // }
}
